import React from 'react';
import PropTypes from 'prop-types';
import { Box, MenuItem } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

const addButtonBlockStyles = {
  alignItems: 'center',
  border: '1px dashed',
  borderColor: 'text.secondary',
  display: 'flex',
  height: '100%',
  width: '277px',
};

const addButtonStyles = {
  alignItems: 'center',
  border: '1px solid',
  borderColor: 'secondary.medium',
  borderRadius: 18,
  color: 'secondary.main',
  display: 'flex',
  margin: '0 auto',
  px: 2,
  py: '6px',
};

const addBlockStyles = {
  background: 'white',
  borderRadius: '2px',
  boxShadow: '4px 8px 24px 1px rgba(0, 0, 0, 0.08)',
  p: 2,
};

const AddItemButton = ({ itemName, onAdd }) => (
  <MenuItem onClick={onAdd} sx={addBlockStyles}>
    <Box sx={addButtonBlockStyles}>
      <Box sx={addButtonStyles}>
        <AddRoundedIcon sx={{ mr: '12px' }} />
        Add {itemName}
      </Box>
    </Box>
  </MenuItem>
);

AddItemButton.propTypes = {
  itemName: PropTypes.string.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default AddItemButton;
